import {XauditModel} from '../xaudit.model';

export class ContactCommsDataModel extends XauditModel {
  Address: string = '';
  CommMethID: string = '';
  ContactId; string = '';
  LOCID: number;
  addrDescription: string = '';
  enumCommLocationID: string;
  enumCommMethodID: string;
  enumCountryID: string;
  isInternational: boolean;
  isPreferred: boolean;
  isOptOut: boolean;
  isOptOutOverwritten: boolean = false;
  typeDescription: string = '';
}
